import axios, { extractData, getAccountSuggestions, getParentAccountSuggestions } from '@atheneum/api'
import { action, computed, extendObservable } from 'mobx'
import moment from 'moment'

// This is not a real status so when changing these values
// Make sure to check that general invocie listing on backend
// is updated as well
const sentToClientOptions = [
  {
    id: 'all',
    name: 'All'
  },
  {
    id: 'sent',
    name: 'Sent'
  },
  {
    id: 'not_sent',
    name: 'Not sent'
  }
]

class CreatedInvoicesStore {
  constructor (staticData) {
    const defaultInvoiceStatus = { id: '', name: 'All' }

    extendObservable(this, {
      loading: false,
      error: null,
      staticData,
      invoices: [],
      noOfInvoices: null,
      currentInvoiceStatus: defaultInvoiceStatus,
      query: this.getEmptyQuery(),
      invoiceStatuses: computed(() => {
        const {
          APPROVED,
          IMPORT,
          PAID
        } = this.staticData.CONST.INVOICE_STATUSES
        let invoiceStatuses = this.staticData.invoiceStatuses.filter(
          status => status.id > APPROVED && status.id < IMPORT
        )
        if (this.query.unpaidOnly) {
          invoiceStatuses = invoiceStatuses.filter(status => status.id < PAID)
        }
        return [defaultInvoiceStatus, ...invoiceStatuses]
      }),
      parentAccountSuggestion: '',
      accountSuggestion: '',
      sentToClientOptions,
      // this is a workaround for the Dropdown compoennt in the InvoicesFilterPanel
      // which misbehaves for some reason
      sentStatus: computed(() => {
        return sentToClientOptions.find(
          option => option.id === this.query.sentStatus
        )
      })
    })
  }

  getEmptyQuery () {
    return {
      type: 'created',
      page: 1,
      limit: 20,
      invoicingEntity: '',
      invoiceNo: '',
      parentAccount: '',
      account: '',
      invoiceStatus: '',
      startDate: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      sentStatus: sentToClientOptions[0].id,
      unpaidOnly: false
    }
  }

  filter () {
    this.loading = true
    const url = '/api/invoice/invoice-listing'
    return axios
      .post(url, this.query)
      .then(res => {
        const responseData = extractData(res)
        this.noOfInvoices = responseData.count
        this.invoices.replace(responseData.invoices)
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  autocompleteParentAccount = value => {
    if (!value) return Promise.resolve([])

    return getParentAccountSuggestions(value).then(result => {
      const autocompleteResult = result.map(element => {
        const suggestion = {
          value: element.id,
          label: element.parentAccountName
        }
        return suggestion
      })
      return autocompleteResult
    })
  }

  autocompleteAccount = value => {
    if (!value) return Promise.resolve([])

    return getAccountSuggestions(value).then(result => {
      const autocompleteResult = result.map(element => {
        const suggestion = {
          value: element.id,
          label: element.companyName
        }
        return suggestion
      })
      return autocompleteResult
    })
  }

  changePage (page) {
    this.query.page = page
    this.filter()
  }

  clearSearch () {
    this.query = this.getEmptyQuery()
    this.parentAccountSuggestion = ''
    this.accountSuggestion = ''
    this.currentInvoiceStatus = { id: '', name: 'All' }
    this.filter()
  }

  setSentToClientFilter = action(sentStatus => {
    this.query.sentStatus = sentStatus.id
    this.filter()
  })
}

export default CreatedInvoicesStore
